import React from 'react';
import { useLanguage } from '../i18n/LanguageContext';

const GourmetSelectionSection = ({ cards = [], onSelect }) => {
  const { t } = useLanguage();
  const g = t.gourmet;

  return (
    <section className="gourmet-section">
      <div className="gourmet-header">
        <div>
          <h2>{g.heading}</h2>
          <p>{g.description}</p>
        </div>
      </div>
      <div className="gourmet-cards" role="list">
        {cards.map((card) => (
          <article
            key={card.id}
            className="gourmet-card"
            role="listitem"
            onClick={() => onSelect?.(card)}
            style={onSelect ? { cursor: 'pointer' } : undefined}
          >
            <div className="gourmet-card-media">
              <img src={card.image.src} alt={card.image.alt} loading="lazy" />
              <div className="gourmet-card-tags">
                <span className="chip chip-primary">{card.tag}</span>
                {card.secondaryTag ? (
                  <span className="chip chip-alt">
                    <span className="material-symbols-rounded" aria-hidden="true">
                      bolt
                    </span>
                    {card.secondaryTag}
                  </span>
                ) : null}
              </div>
            </div>
            <h3>{card.title}</h3>
            <div className="gourmet-card-meta">
              <span>
                <span className="material-symbols-rounded" aria-hidden="true">
                  schedule
                </span>
                {card.time}
              </span>
              <span>
                <span className="material-symbols-rounded" aria-hidden="true">
                  local_fire_department
                </span>
                {card.calories}
              </span>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
};

export default GourmetSelectionSection;
